<div class="empty">
  @if (icon()) {
    <dsy-icon class="icon" name="help" library="system" size="24px" color="#5738ff" density="default" elevation="auto"></dsy-icon>
  }
  <h3 class="title" [class.title--emphasized]="emphasized()">{{ title() | translate }}</h3>
  @if (subtitle()) {
    <p class="subtitle">{{ subtitle() | translate }}</p>
  }
  @if (showPermissionStatus()) {
    <h4 class="permission-status">{{ permissionText() | translate }}</h4>
  }
</div>
